export function renderPerspective() {
  return `
    <section class="relative bg-[#050505] border-b border-[#1C201E] overflow-hidden py-24 md:py-32 px-6 lg:px-16">
      <!-- Dithered Background Pattern Simulation -->
      <div class="absolute inset-0 opacity-20 bg-cross-dot pointer-events-none"></div>

      <!-- Subtle background typographic watermark -->
      <div class="absolute right-6 -bottom-10 font-mono text-8xl font-black text-white/[0.015] select-none pointer-events-none uppercase tracking-widest hidden lg:block">
        SYSTEMS &amp; SHADERS
      </div>

      <!-- Cyan/Electric Laser Eye Ray Accent Line -->
      <div class="absolute top-1/2 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#22d3ee]/80 to-transparent shadow-[0_0_15px_#22d3ee] pointer-events-none"></div>

      <div class="max-w-7xl mx-auto relative z-10 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <div class="md:col-span-8">
          <div class="font-mono text-[11px] tracking-widest text-neutral-400 uppercase flex items-center gap-3 mb-4">
            <span>CODE / DESIGN / EXPERIMENT</span>
            <span class="text-neutral-600">•</span>
            <span class="text-neutral-300">RANJIKA NETHPRIYA</span>
          </div>
          <h2 class="text-5xl sm:text-7xl md:text-8xl font-bold tracking-tight text-[#FAF8F5] leading-[0.92] font-display">
            Curious by <br/>
            nature. <br/>
            Building by <span class="font-serif italic font-normal text-cyan-telemetry">choice.</span>
          </h2>
        </div>

        <div class="md:col-span-4 font-mono text-xs text-neutral-300 border-l border-neutral-800/80 pl-6 sm:pl-8 space-y-3 bg-[#050505]/60 backdrop-blur-sm py-4">
          <p class="leading-relaxed font-normal text-neutral-200 tracking-wide text-xs">
            "Writing code is not merely executing instructions: it is sculpting thought into deterministic reality."
          </p>
          <span class="inline-block text-[10px] text-cyan-telemetry tracking-wider font-semibold uppercase">RANJIKA NETHPRIYA // ARCHIVES 2026</span>
        </div>
      </div>
    </section>
  `;
}
